export default __webpack_public_path__ + "static/media/pvn-arte-6.8a70d5a7.webp";